import React from 'react';
import { Box } from 'wt-ui';
import PropTypes from 'prop-types';
import CancelIcon from '../../assets/icons/CancelIcon';
import CryptoIcon from '../../assets/icons/CryptoIcon';
import CommodityIcon from '../../assets/icons/CommodityIcon';
import NextBigThingIcon from '../../assets/icons/NextBigThingIcon';
import { CRYPTO_CLARIFIED, THE_COMMODITY_EXCHANGE, THE_NEXT_BIG_THING } from '../../services/Constants';
import './index.css';

const getIconFromName = (iconName, iconProps) => {
  switch (iconName) {
    case THE_COMMODITY_EXCHANGE:
      return <CommodityIcon {...iconProps} />;
    case CRYPTO_CLARIFIED:
      return <CryptoIcon {...iconProps} />;
    case THE_NEXT_BIG_THING:
      return <NextBigThingIcon {...iconProps} />;
    default:
      return <CryptoIcon {...iconProps} />;
  }
};

const Chip = (props) => {
  const { title, setSelectedFilter, isSelected } = props;

  const handleFilterClick = () => {
    setSelectedFilter(title);
  };
  return (
    <Box
      background="transparent"
      direction="row"
      justify="center"
      onClick={handleFilterClick}
      round="medium"
      className="custom-box"
      gap="medium"
    >
      <div className={`${isSelected ? 'selected' : ''} chip`}>
        <div className="chip-head">{getIconFromName(title)}</div>
        <div className="chip-content">{title}</div>
        <div className="chip-close">{isSelected && <CancelIcon />}</div>
      </div>
    </Box>
  );
};
Chip.propTypes = {
  title: PropTypes.string.isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default Chip;
